export const ERROR_MESSAGE = {
  invalidCharacters: "The field contains forbidden characters.",
  invalidFormat: "The email must be a valid email address.",
};

export default {
  errors: ERROR_MESSAGE,
};
